import React from 'react';
import ContactSourceIcon from 'flow/components/custom-components/ContactSourceIcon';
import IconBadge from 'flow/components/ui-components/IconBadge';
import { TypedMap } from 'flow/types/TypedMap';

import { ContactType } from 'flow/utils/extension-utils';

interface Props {
    contact: TypedMap<{
        _discriminator: 'ContactDTO';
        sourceIcon?: string;
        type?: string;
    }>;
    size?: string;
    className?: string;
}

const ContactTypeIcon = ({ contact, size = '0.875rem', className }: Props) => {
    if (!contact) {
        return null;
    }

    if (contact.get('sourceIcon')) {
        return (
            <ContactSourceIcon
                src={contact.get('sourceIcon')}
                className={className}
            />
        );
    }

    if (
        contact.get('type') === ContactType.shared.key &&
        contact.get('type') !== 'personal'
    ) {
        return <IconBadge iconKey="shared" size={size} className={className} />;
    }

    if (contact.get('type') === ContactType.global.key) {
        return <IconBadge iconKey="lookUp" size={size} className={className} />;
    }

    return null;
};

export default ContactTypeIcon;
